import { lazy, Suspense } from "react";

import { Loader } from "@prophero-ds/cx-react";

import ScreenManagerLayout from "./components/ScreenManagerLayout";
import ProdScreenManager from "./ProdScreenManager";

/**
 * Main App Component
 * Production renders ProdScreenManager directly: a lazy boundary here would show
 * the Suspense fallback and delay the form by React's ~300 ms reveal throttle
 * (CX-902). The dev manager stays lazy so it never ships to production.
 */
const ScreenManager = import.meta.env.DEV
  ? lazy(() => import("./DevScreenManager"))
  : ProdScreenManager;

export default function App() {
  return (
    <ScreenManagerLayout>
      <Suspense
        fallback={
          <div className="flex min-h-screen items-center justify-center">
            <Loader name="typing-dots" size="6" />
          </div>
        }
      >
        <ScreenManager />
      </Suspense>
    </ScreenManagerLayout>
  );
}
